// extracted by mini-css-extract-plugin
module.exports = {"main":"Tools_main__2RJdQ"};